export default {
  // Nav
  'nav.services': '서비스',
  'nav.cases': '사례 연구',
  'nav.about': '회사 소개',
  'nav.contact': '문의하기',
  'nav.cta': '무료 상담',

  // Hero
  'hero.tag': '/ 블록체인 풀사이클 전개',
  'hero.title.line1': '디지털 제품을',
  'hero.title.line2': '안전하게 온체인으로',
  'hero.subtitle': 'Angle Forty는 디지털 제품 팀이 블록체인에서 자신 있게 출시할 수 있도록 전략, 보안 배포, 유통, 모니터링 및 장기 최적화까지 토탈 지원합니다.',
  'hero.cta.primary': '온체인 배포 시작하기',
  'hero.cta.secondary': '서비스 자세히 보기',
  'hero.stat.projects': '배포 완료 프로젝트',
  'hero.stat.chains': '지원 체인',
  'hero.stat.uptime': '평균 가동률',
  'hero.stat.experts': '사내 전문가',

  // Marquee
  'marquee.item1': 'ETHEREUM · 이더리움',
  'marquee.item2': 'SOLANA · 솔라나',
  'marquee.item3': 'BNB CHAIN · 바이낸스 체인',
  'marquee.item4': 'POLYGON · 폴리곤',
  'marquee.item5': 'ARBITRUM · 아비트럼',
  'marquee.item6': 'BASE · 베이스',
  'marquee.item7': 'AVALANCHE · 아발란체',

  // About
  'about.tag': '/ 회사 소개',
  'about.title': '전략부터 최적화까지, 풀사이클 온체인 파트너',
  'about.desc': 'Angle Forty는 블록체인 핵심 프로토콜, 핀테크, 제품 운영 분야의 시니어 엔지니어와 전략가들이 모여 설립했습니다. 전 세계 120개 이상의 디지털 제품 팀이 안전하고 세련된 방식으로 온체인 비전을 실현하도록 지원하고 있습니다.',
  'about.number': '01',
  'about.number.label': '풀사이클 온체인 프레임워크',
  'about.number.desc': '시장 조사, 토큰노믹스 설계, 스마트 컨트랙트 배포부터 유통, 데이터 모니터링, 지속적인 최적화까지 4단계를 매끄럽게 통합하여 고객이 제품 자체에 집중할 수 있도록 합니다.',
  'about.cta': '프레임워크 자세히 보기',

  // Services
  'services.tag': '/ 핵심 서비스',
  'services.title.line1': '온체인 런치.',
  'services.title.line2': '데이터 기반 성장.',
  'services.desc': '4단계, 통합 원스톱 제공. 모든 단계는 전담 시니어 팀이 철저히 지원합니다.',
  'services.s1.title': '전략 및 컨설팅',
  'services.s1.desc': '제품 포지셔닝, 타겟 체인, 토큰노믹스를 심층 분석하여 실행 가능한 온체인 로드맵을 수립합니다.',
  'services.s1.tag': 'Phase 01',
  'services.s2.title': '온체인 배포',
  'services.s2.desc': '스마트 컨트랙트 감사, 멀티체인 배포, 강화된 보안으로 모든 거래와 자산의 추적 가능성을 보장합니다.',
  'services.s2.tag': 'Phase 02',
  'services.s3.title': '제품 운영',
  'services.s3.desc': '유통, 커뮤니티, 콘텐츠 전략, 캠페인을 통해 타겟 사용자에게 대규모로 도달합니다.',
  'services.s3.tag': 'Phase 03',
  'services.s4.title': '지원 및 최적화',
  'services.s4.desc': '24시간 연중무휴 모니터링, 분석 대시보드, 지속적인 최적화로 시장 사이클을 넘어 지속 가능한 프로젝트를 실현합니다.',
  'services.s4.tag': 'Phase 04',
  'services.s.badge.hot': '주목',

  // Cases
  'cases.tag': '/ 사례 연구',
  'cases.title': '신뢰받는 온체인 파트너',
  'cases.desc': 'NFT 디지털 컬렉터블의 엔드투엔드 런치 — 아트 제작부터 온체인 배포까지.',
  'cases.viewAll': '모든 사례 보기',
  'cases.c1.name': 'Pixel Origin',
  'cases.c1.category': 'NFT · 아트 런치 플랫폼',
  'cases.c1.tvl': '거래량 2,800 ETH',
  'cases.c2.name': 'Vault Society',
  'cases.c2.category': 'NFT · 멤버십 패스',
  'cases.c2.tvl': '15,000+ 발행',
  'cases.c3.name': 'MetaForge',
  'cases.c3.category': 'NFT · 게이밍 자산',
  'cases.c3.tvl': '거래량 1,200만 달러',
  'cases.c4.name': 'Eden Drop',
  'cases.c4.category': 'NFT · 마켓플레이스',
  'cases.c4.tvl': '월간 활성 28만',

  // Testimonial
  'testimonial.tag': '/ 고객 후기',
  'testimonial.quote': 'Angle Forty는 당초 6개월이 걸릴 것으로 예상했던 멀티체인 배포를 단 6주 만에 완료했습니다. 대시보드 덕분에 운영팀이 처음으로 온체인 비즈니스를 명확히 파악할 수 있게 되었습니다.',
  'testimonial.author': 'Yvonne Liao',
  'testimonial.role': 'Pixel Origin 공동 창업자',
  'testimonial.verified': '인증된 파트너',

  // CTA
  'cta.tag': '/ 문의하기',
  'cta.title': '온체인 런치 준비되셨나요?',
  'cta.desc': '프로젝트에 대해 알려주세요. 시니어 컨설턴트가 24시간 이내에 연락드려 최적의 배포 계획을 제안해 드립니다.',
  'cta.form.name': '이름',
  'cta.form.email': '이메일',
  'cta.form.company': '회사 / 프로젝트명',
  'cta.form.type': '프로젝트 유형',
  'cta.form.type.nft.art': 'NFT 아트 / 디지털 컬렉터블',
  'cta.form.type.nft.gaming': 'NFT 게이밍 자산',
  'cta.form.type.nft.membership': 'NFT 멤버십 / 유틸리티',
  'cta.form.type.nft.marketplace': 'NFT 마켓플레이스 / 플랫폼',
  'cta.form.type.other': '기타',
  'cta.form.message': '프로젝트에 대해 간략히 설명해 주세요 (500자 이내)',
  'cta.form.submit': '상담 보내기',
  'cta.form.submitting': '전송 중…',
  'cta.form.success': '문의해 주셔서 감사합니다. 24시간 이내에 연락드리겠습니다.',
  'cta.form.error': '전송에 실패했습니다. 잠시 후 다시 시도하시거나 hello@angleforty.com 으로 직접 이메일을 보내주세요.',

  // Footer
  'footer.brandDesc': 'Angle Forty — 모든 디지털 제품을 안전하고 세련되게 블록체인으로.',
  'footer.nav.title': '내비게이션',
  'footer.contact.title': '문의',
  'footer.social.title': '팔로우',
  'footer.newsletter': '뉴스레터 구독',
  'footer.newsletter.desc': '월 1회. 업계 인사이트와 사례 리뷰만을 제공합니다.',
  'footer.newsletter.placeholder': '이메일 주소 입력',
  'footer.newsletter.button': '구독',
  'footer.address.title': '주소',
  'footer.address.value': '香港中環皇后大道中9号',
  'footer.phone': '+852 3150 0000',
  'footer.email': 'hello@angleforty.com',
  'footer.copyright': '© 2026 Angle Forty Technology Ltd. All rights reserved.',
  'footer.policy.privacy': '개인정보',
  'footer.policy.terms': '이용약관',

  // Language
  'lang.zh-Hant': '繁中',
  'lang.zh-Hans': '简中',
  'lang.en': 'EN',
  'lang.ja': '日文',
  'lang.ko': '한국어',
};